// Auto-generated - DO NOT EDIT
import type { IconifyJSON } from '@iconify/types';

export const iconCollections: Record<string, IconifyJSON> = {};

export const USED_ICONS: readonly string[] = [
  "akar-icons:chevron-up",
  "akar-icons:water",
  "ant-design:file-excel-outlined",
  "ant-design:file-pdf-outlined",
  "ant-design:stop-outlined",
  "bi:check",
  "bi:cloud-hail",
  "bi:cloud-rain-heavy",
  "bi:cloud-snow",
  "bi:layers-half",
  "bi:thermometer-sun",
  "bx:add-to-queue",
  "carbon:calendar",
  "carbon:checkmark-outline",
  "carbon:error-outline",
  "carbon:lightning",
  "carbon:locked",
  "charm:cross",
  "ci:external-link",
  "cil:window",
  "clarity:upload-cloud-line",
  "entypo:sound-mix",
  "eva:activity-outline",
  "eva:alert-circle-fill",
  "eva:alert-triangle-fill",
  "eva:archive-fill",
  "eva:arrow-ios-downward-fill",
  "eva:arrow-ios-forward-fill",
  "eva:checkmark-circle-2-fill",
  "eva:checkmark-circle-2-outline",
  "eva:chevron-down-fill",
  "eva:chevron-left-fill",
  "eva:chevron-right-fill",
  "eva:chevron-up-fill",
  "eva:clock-fill",
  "eva:clock-outline",
  "eva:close-fill",
  "eva:cloud-download-outline",
  "eva:coffee-fill",
  "eva:done-all-fill",
  "eva:edit-fill",
  "eva:file-text-outline",
  "eva:home-fill",
  "eva:info-fill",
  "eva:menu-2-fill",
  "eva:more-vertical-fill",
  "eva:plus-fill",
  "eva:refresh-fill",
  "eva:search-fill",
  "eva:settings-2-fill",
  "eva:settings-2-outline",
  "eva:trending-down-fill",
  "eva:trending-up-fill",
  "eva:undo-fill",
  "fa-regular:edit",
  "fa-solid:file",
  "fa-solid:file-audio",
  "fa-solid:file-csv",
  "fa-solid:file-excel",
  "fa-solid:file-image",
  "fa-solid:file-pdf",
  "fa-solid:file-powerpoint",
  "fa-solid:file-upload",
  "fa-solid:file-word",
  "fluent:document-table-search-20-regular",
  "fluent:settings-32-regular",
  "formkit:arrowright",
  "gis:layer",
  "gridicons:create",
  "heroicons-outline:lightning-bolt",
  "ic:baseline-edit",
  "ic:baseline-file-download",
  "ic:outline-arrow-forward-ios",
  "ic:outline-cancel",
  "ic:outline-email",
  "ic:outline-percentage",
  "ic:round-filter-list",
  "icon-park-outline:return",
  "ion:warning",
  "la:fire-alt",
  "lucide:edit",
  "material-symbols:add-box-outline",
  "material-symbols:arrow-back-ios",
  "material-symbols:arrow-back-ios-new-rounded",
  "material-symbols:arrow-drop-down-rounded",
  "material-symbols:arrow-drop-up-rounded",
  "material-symbols:arrow-forward-ios",
  "material-symbols:arrow-forward-ios-rounded",
  "material-symbols:arrow-outward",
  "material-symbols:chevron-left",
  "material-symbols:close",
  "material-symbols:edit-sharp",
  "material-symbols:error-rounded",
  "material-symbols:file-open-outline-rounded",
  "material-symbols:folder-managed-outline-rounded",
  "material-symbols:heat",
  "material-symbols:info-outline",
  "material-symbols:link",
  "material-symbols:lock-open-rounded",
  "material-symbols:mail-outline",
  "material-symbols:open-in-new",
  "material-symbols:tune",
  "material-symbols:undo",
  "material-symbols:view-column",
  "mdi:account-circle-outline",
  "mdi:account-group-outline",
  "mdi:account-outline",
  "mdi:alert",
  "mdi:alert-circle",
  "mdi:alpha-u-box",
  "mdi:archive-arrow-up-outline",
  "mdi:archive-outline",
  "mdi:arrow-down",
  "mdi:arrow-expand-horizontal",
  "mdi:arrow-right",
  "mdi:arrow-right-thick",
  "mdi:arrow-up",
  "mdi:bed-outline",
  "mdi:bell-outline",
  "mdi:briefcase-outline",
  "mdi:calculator",
  "mdi:calendar",
  "mdi:cancel",
  "mdi:chart-bar",
  "mdi:chart-bar-stacked",
  "mdi:chart-timeline",
  "mdi:chart-timeline-variant-shimmer",
  "mdi:check",
  "mdi:check-circle",
  "mdi:check-decagram-outline",
  "mdi:chevron-down",
  "mdi:chevron-left",
  "mdi:chevron-right",
  "mdi:chevron-up",
  "mdi:circle-half-full",
  "mdi:clipboard-check-outline",
  "mdi:clipboard-pulse-outline",
  "mdi:clipboard-text-history-outline",
  "mdi:clock",
  "mdi:close",
  "mdi:close-circle",
  "mdi:cog-outline",
  "mdi:compass-outline",
  "mdi:content-copy",
  "mdi:content-duplicate",
  "mdi:crane",
  "mdi:creation-outline",
  "mdi:currency-eur",
  "mdi:database-outline",
  "mdi:day-temperature",
  "mdi:delete",
  "mdi:delete-variant",
  "mdi:desk",
  "mdi:domain",
  "mdi:door",
  "mdi:download",
  "mdi:drag",
  "mdi:drop-outline",
  "mdi:electricity-outline",
  "mdi:energy-circle",
  "mdi:external-link",
  "mdi:eye-off",
  "mdi:factory",
  "mdi:file-code-outline",
  "mdi:file-compare",
  "mdi:file-document-check",
  "mdi:file-download-outline",
  "mdi:file-multiple-outline",
  "mdi:file-outline",
  "mdi:file-tree-outline",
  "mdi:file-upload",
  "mdi:file-upload-outline",
  "mdi:fit-to-screen-outline",
  "mdi:flag",
  "mdi:flash-outline",
  "mdi:folder-move",
  "mdi:folder-outline",
  "mdi:folder-zip-outline",
  "mdi:format-list-bulleted-square",
  "mdi:gauge",
  "mdi:globe",
  "mdi:help-circle",
  "mdi:help-circle-outline",
  "mdi:home-city-outline",
  "mdi:home-outline",
  "mdi:home-remove-outline",
  "mdi:home-roof",
  "mdi:home-variant-outline",
  "mdi:hospital-box-outline",
  "mdi:house-city-outline",
  "mdi:information",
  "mdi:information-outline",
  "mdi:keyboard-arrow-down",
  "mdi:label-outline",
  "mdi:landslide",
  "mdi:layers-outline",
  "mdi:link-variant",
  "mdi:logout",
  "mdi:magnify",
  "mdi:map-marker",
  "mdi:microscope",
  "mdi:office-building",
  "mdi:office-building-outline",
  "mdi:office-building-plus-outline",
  "mdi:open-in-new",
  "mdi:paperclip",
  "mdi:pause-circle-outline",
  "mdi:pencil",
  "mdi:pencil-box",
  "mdi:pencil-outline",
  "mdi:percent-outline",
  "mdi:play-circle-outline",
  "mdi:plus",
  "mdi:question-mark-circle-outline",
  "mdi:refresh",
  "mdi:reload",
  "mdi:restore",
  "mdi:shopping-outline",
  "mdi:soccer",
  "mdi:speedometer",
  "mdi:speedometer-medium",
  "mdi:speedometer-slow",
  "mdi:square-edit-outline",
  "mdi:star",
  "mdi:stopwatch-outline",
  "mdi:surface-area",
  "mdi:texture-box",
  "mdi:theatre",
  "mdi:timer-sand-empty",
  "mdi:translate",
  "mdi:transportation",
  "mdi:trash-can-outline",
  "mdi:tray-arrow-down",
  "mdi:tsunami",
  "mdi:tune",
  "mdi:undo-variant",
  "mdi:users",
  "mdi:warning",
  "mdi:water",
  "mdi:weather-windy",
  "mdi:zoom-in-outline",
  "mdi:zoom-out-outline",
  "mingcute:external-link-line",
  "mingcute:loading-fill",
  "octicon:checklist-16",
  "pepicons-pop:leave",
  "ph:dot-outline-fill",
  "ph:folder",
  "ph:note-pencil-fill",
  "ph:wall-light",
  "ph:x",
  "uil:layers",
  "vaadin:line-h",
  "wi:earthquake",
  "wpf:snow",
  "zondicons:exclamation-solid",
  "zondicons:information-outline"
] as const;
